import * as AvatarPrimitive from "@radix-ui/react-avatar";

export const Picture = AvatarPrimitive.Root;
export const PictureImage = AvatarPrimitive.Image;
export const PictureFallback = AvatarPrimitive.Fallback;
